import type {
  MintPartnerAssertionRequestProto_Body,
  MintPartnerAssertionResponseProto,
} from "@noom/noom-contracts/noom_contracts/identity/partner_assertion/partner_assertion_service";
import { Api } from "@noom/noomscape";

import axios from "axios";

Api.register(
  "identity.mintPartnerAssertion",
  async ({
    accessToken,
    ...data
  }: MintPartnerAssertionRequestProto_Body & {
    accessToken: string;
  }): Promise<MintPartnerAssertionResponseProto> => {
    const response = await axios({
      baseURL: window.ENV.IDENTITY_SERVER_URL,
      data,
      method: "POST",
      url: "/identity/mintPartnerAssertion",
      urlWithPathParams: "/identity/mintPartnerAssertion",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  },
);
